<div class="add-container">
    <h1 class="add-title">Adaugă înregistrare</h1>

    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Nume</mat-label>
                <input type="text" matInput formControlName="last_name" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['last_name'].valid && form.controls['last_name'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Prenume</mat-label>
                <input type="email" matInput formControlName="first_name" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['first_name'].valid && form.controls['first_name'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>CNP</mat-label>
                <input type="text" matInput formControlName="cnp" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['cnp'].valid && form.controls['cnp'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Număr certificat deces</mat-label>
                <input type="text" matInput formControlName="cert_number" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['cert_number'].valid && form.controls['cert_number'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Dată emitere certificat deces</mat-label>
                <input matInput formControlName="cert_date" [matDatepicker]="startPicker" readonly
                    (focus)="startPicker.open()" />
                <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
            <mat-error *ngIf="!form.controls['cert_date'].valid && form.controls['cert_date'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="add-field">
            <mat-form-field appearance="fill">
                <mat-label>Observații</mat-label>
                <textarea type="text" matInput rows="3" formControlName="obs"></textarea>
            </mat-form-field>
            <mat-error *ngIf="!form.controls['cert_number'].valid && form.controls['cert_number'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>